<header class="navbar bg-white text-dark">
  <div class="container-xl justify-content-start">
    <h1 class="m-0">
      {{ pageTitle() }}
    </h1>
  </div>
</header>
